import {GoogleAdsConversionEventInterface} from "../shared/interfaces/marketing/google-ads-conversion-event.interface";

const GoogleAdsService = (() => {
	function sendConversionEvent(eventData: GoogleAdsConversionEventInterface) {
		window.gtag('event', 'conversion', {
			'send_to': `AW-${eventData.conversionId}/${eventData.conversionLabel}`,
			'transaction_id': eventData.transactionId,
			...(eventData.value > 0 && { 'value': eventData.value }),
			...(eventData.value > 0 && { 'currency': process.env.REACT_APP_CURRENCY }),
		})
	}

	return {
		sendConversionEvent: sendConversionEvent,
	}
})();

export default GoogleAdsService;
